import React from 'react'
import { Sound } from '../types/Sound'
import { AudioState } from '../types/AudioState'
import PlayButton from './PlayButton'

interface SoundItemProps {
  sound: Sound
  audioState: AudioState
  onPlay: (soundPath: string) => void
  onStop: (soundPath: string) => void
  onDelete?: (soundId: string) => void
  className?: string
}

const SoundItem: React.FC<SoundItemProps> = ({
  sound,
  audioState,
  onPlay,
  onStop,
  onDelete,
  className = ''
}) => {
  const { label, filePath } = sound
  const { isPlaying, error, isLoading } = audioState

  const getItemClass = () => {
    const baseClass = 'sound-item'
    const stateClass = isLoading ? 'loading' : isPlaying ? 'playing' : error ? 'error' : 'idle'
    return `${baseClass} ${stateClass} ${className}`.trim()
  }

  return (
    <div className={getItemClass()}>
      <div className="sound-item-content">
        <div className="sound-item-info">
          <h3 className="sound-item-label">{label}</h3>
          <p className="sound-item-category">{sound.category}</p>
          {error && (
            <p className="sound-item-error" role="alert">
              {error}
            </p>
          )}
          {isLoading && (
            <p className="sound-item-loading" aria-live="polite">
              Loading sound...
            </p>
          )}
        </div>
        <div className="sound-item-controls">
          <PlayButton
            soundPath={filePath}
            audioState={audioState}
            onPlay={onPlay}
            onStop={onStop}
          />
          {onDelete && (
            <button
              className="sound-item-delete-button"
              onClick={() => onDelete(sound.id)}
              title={`Delete ${label}`}
              aria-label={`Delete ${label}`}
            >
              🗑️
            </button>
          )}
        </div>
      </div>
      {isPlaying && (
        <div className="sound-item-playing-indicator" aria-hidden="true">
          <div className="sound-wave">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      )}
    </div>
  )
}

export default SoundItem
